/* eslint-disable new-cap, no-console */
const RR_CT = '&ct=';
let rrAdapter = null;

const taggingEventsListeners = {
	cartUpdated(event, data) {
		rrAdapter.resetData();

		if (data && Array.isArray(data.addToCart)) {
			data.addToCart.forEach(cartEntry => {
				rrAdapter.addCartEntry(cartEntry.skuID || '');

				if (cartEntry.skuCategoryID) {
					rrAdapter.addCategoryHintId(cartEntry.skuCategoryID);
				}
			});
		}
	},

	rrnotify(rrUrl) {
		let modifiedUrl = rrUrl;
		if (console && console.info) {
			console.info(`Sending rrUrl: ${rrUrl}`);
		}
		if (rrUrl) {
			if (rrUrl.indexOf(RR_CT) > -1) {
				modifiedUrl = rrUrl.substr(0, rrUrl.indexOf(RR_CT));
			}
			window.od.Ajax({
				// url: 'http://recs.algorecs.com/' + rrUrl,
				url: modifiedUrl,
				data: null,
				success(data) {
					if (console && console.info) {
						const dataLog = data.split('>')[0] || data;
						console.info(`rrUrl xhr success: ${dataLog}...`);
					}
				},
			});
		} else if (console && console.warn) {
			console.warn('rrnotify trigger failed');
		}
	},
};

export default function initializeEventListeners(theAdapter) {
	rrAdapter = theAdapter;

	Object.keys(taggingEventsListeners).forEach(eventName => {
		const eventHandler = taggingEventsListeners[eventName];
		document.addEventListener(eventName, event => {
			eventHandler(event, event.detail);
		});
	});
}
